import {
  getEducationQualificationLabel,
  getEducationRecordFields,
  normalizeEducationQualification,
  sortEducationRecords,
} from "../../../../utils/educationHelpers";
import ReviewField from "../ReviewField";
import SectionDocuments from "../SectionDocuments";
import "./EducationSection.css";

const EducationSection = ({
  formData,
  fieldFlags,
  flagModeEnabled,
  restrictToUpdatedFields,
  updatedFields,
  flagModal,
  focusedFlagKey,
  onOpenFlagModal,
  onUpdateField,
  documents = [],
  getFileIcon,
  onPreviewDoc,
}) => {
  const education = formData?.education || {};
  const highestKey = normalizeEducationQualification(
    education.highest_qualification,
  );
  const sortedRecords = sortEducationRecords(
    Array.isArray(education.records) ? education.records : [],
  );

  const fieldProps = {
    sectionKey: "education",
    formData,
    fieldFlags,
    flagModeEnabled,
    restrictToUpdatedFields,
    updatedFields,
    flagModal,
    focusedFlagKey,
    onOpenFlagModal,
    onUpdateField,
  };

  let content;
  if (!highestKey && sortedRecords.length === 0) {
    content = (
      <div className="rr-education-empty">No education records available.</div>
    );
  } else {
    content = (
      <>
        {sortedRecords.map((record) => {
          const sourceIndex = (education.records || []).indexOf(record);
          const recordIndex = sourceIndex >= 0 ? sourceIndex : 0;
          const qualificationLabel = getEducationQualificationLabel(
            record.qualification,
          );
          const fields = getEducationRecordFields(record);
          const isHighest =
            normalizeEducationQualification(record.qualification) ===
            highestKey;

          return (
            <div
              className="rr-education-record"
              key={`education-record-${record.qualification}-${recordIndex}`}
            >
              <div className="rr-education-record-head">
                <div className="form-subhead">{qualificationLabel}</div>
                {isHighest ? (
                  <span className="rr-education-badge">Highest</span>
                ) : null}
              </div>
              <div className="flex flex-wrap">
                {fields.map((field) => (
                  <ReviewField
                    key={`${recordIndex}-${field.key}`}
                    {...fieldProps}
                    field={field}
                    options={{
                      recordIndex,
                      recordLabel: qualificationLabel,
                      labelOverride: field.label,
                    }}
                  />
                ))}
              </div>
            </div>
          );
        })}
      </>
    );
  }

  return (
    <>
      <div className="flex flex-wrap">{content}</div>
      <SectionDocuments
        sectionKey="education"
        documents={documents}
        getFileIcon={getFileIcon}
        onPreviewDoc={onPreviewDoc}
        fieldFlags={fieldFlags}
        flagModeEnabled={flagModeEnabled}
        restrictToUpdatedFields={restrictToUpdatedFields}
        updatedFields={updatedFields}
        flagModal={flagModal}
        focusedFlagKey={focusedFlagKey}
        onOpenFlagModal={onOpenFlagModal}
      />
    </>
  );
};

export default EducationSection;
